import React from "react";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import RenderRoutes from '../../route/renderRoutes';


function DefaultLayout() {
  return (
    <div>
      <Header />
       <RenderRoutes layout="default"/> 
      <Footer/>
    </div>    
  );
}

export default withRouter(DefaultLayout);